import React, { Component } from 'react';
import {
    Container,
    Button,
} from 'reactstrap';
import CollapseCard from '../CollapseCard/CollapseCard';
import CompanyContext from '../../auth/CompanyContext';
import * as utilities from '../../utilities';
class Mail extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);

        this.state = {
            html: ''
        }
    };

    handleMail = () => {
        fetch('/api/mail/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
    }

    dailyUserActivityReport = () => {
        fetch('/api/mail/dailyUserActivityReport/all', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        }).then(results => results.json())
            .then((results) => {
                if (results?.emailSent === true) {
                    utilities.addToast('Daily activity report email sent.', 5, 'success');
                } else if (results?.emailSent === false) {
                    utilities.addToast('Daily activity report email failed to send.', 5, 'danger');
                }

                if (results.html) {
                    this.setState({
                        html: results.html
                    })
                } else {
                    this.setState({
                        html: "No Results"
                    })
                }
            })
            .catch(() => {
                utilities.addToast('Unable to generate daily activity report.', 5, 'danger');
                this.setState({
                    html: "No Results"
                });
            })
    }

    monthlyUserActivityReport = () => {
        fetch('/api/mail/monthlyUserActivityReport/5fa43880917c1b006ec3daf4', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        }).then(results => results.json())
            .then((results) => {
                if (results.data) {
                    this.setState({
                        html: results.html
                    })
                } else {
                    this.setState({
                        html: "No Results"
                    })
                }
            })
    }

    render() {
        return (
            <Container fluid>
                <CollapseCard title="Mail Tests" open={false} header="h3">
                    <Button className='mx-1' onClick={this.handleMail}>Send Test Email</Button>
                    <Button className='mx-1' onClick={this.dailyUserActivityReport}>Send Daily User Activity Report</Button>
                    <Button className='mx-1' onClick={this.monthlyUserActivityReport}>Send Monthly User Activity Report</Button>
                    <div className='m-5' dangerouslySetInnerHTML={{ __html: this.state.html }}></div>
                </CollapseCard>
            </Container>
        );
    }
}

export default Mail;
